import { MetaBlockType } from 'contexts/Flow/types'

export const SIMILARITY_ACCURACY_DEFAULT = 0.3
export const SIMILARITY_ACCURACY_BLOCKS_TYPE: MetaBlockType[] = [
  'Multiple',
  'AI123',
  'SimpleCarousel',
]
